/* eslint-disable max-len */
export const family = {
    title: 'Управление семьей',
    title2: 'Информация о счете',
    title3: 'Объединяйтесь в семью Status',
    subtitle3: 'Копите и тратьте мили вместе с другими участниками программы',
    terms_link: 'Подробные условия семейного участия',
    participation_type: {
        head: 'Глава семьи',
        participant: 'Участник',
    },
    invite_modal: {
        title: 'Приглашение пользователя',
        info: "Для приглашения пользователя требуется указать логин (email) пользователя в системе <span class='text-info'>Utair Status</span>.<br />",
        login_label: 'Логин приглашаемого пользователя',
        success:
            'Мы отправили пользователю письмо на email с приглашением присоединиться к вашей семье. Как только пользователь примет приглашение, вы увидите его в списке членов семьи.',
        invite: 'Пригласить',
        error: {
            user_registered: 'Пользователь уже зарегистрирован',
        },
    },
    leave_modal: {
        title: 'Покинуть семью',
        info: 'Вы уверены, что хотите покинуть семью?',
        yes: 'Да',
        cancel: 'Отмена',
    },
    terms: {
        title: 'Условия семейного участия',
        list: '<ol><li>В семейный счет можно объединить до 7 персональных аккаунтов участников.Каждый  участник может быть включен в состав только одного семейного счета.</li><li>Участник, создавший семейный счет, становится его главой и получает право добавлять,исключать участников или назначить нового главу. Главой семейного счета может стать участник, достигший 18-летнего возраста.</li><li>Чтобы включить в состав нового участника, главе семейного счета необходимо принять запрос на присоединение к семейному счету, направленный индивидуальным участником из своего личного кабинета. Запрос на участие в составе семейного счета может быть направлен только активным участником  программы.</li><li>Участники семейного счета могут использовать мили, накопленные на своих персональных счетах. Глава счета имеет право использовать баланс семейного счета или наделить таким правом любого участника старше 14 лет.</li><li>Минимальный период участия в составе семейного счета 6 месяцев. Участник не может выйти или быть исключен из состава участников до истечения минимального периода. Глава счета может выйти из состава участников, назначив нового главу счета.</li><li>На персональном счете участника сохраняются мили, не использованные на момент его исключения или выхода из состава участников семейного счета.</li></ol>',
    },
    invite_to_family: {
        title: 'Пригласить в семью',
    },
    create_family: {
        title: 'Создать семью',
        button: 'Создать семью',
        short_button: 'Создать',
    },
    join_family: {
        title: 'Вступить в семью',
        button: 'Вступить в семью',
        short_button: 'Вступить',
        success:
            'Мы отправили пользователю письмо на email с запросом на вступление в его семью. Как только пользователь примет приглашение, вы вступите в его семью.',
    },
    errors: {
        incomplete: 'Данный пользователь не завершил регистрацию в Utair Status',
        invalid_params: 'Переданы неверные параметры',
        invite_not_auth: 'Вы должны быть авторизованным чтобы принять приглашение.',
        invite_another_user: 'Нельзя принять приглашение за другого пользователя.',
        has_no_flights:
            'Для участия в семье надо иметь хоть один перелёт. Если вы уже летали с Utair, можете восстановить полёт',
        has_no_flights_invited: 'Для приглашения участника в семью, ему необходимо иметь хотя бы один перелет.',
        has_no_flights_link: 'ЗДЕСЬ',
        household_member_exclude: 'Запрещено удалять участника семьи',
        household_no_user: 'Пользователь не найден',
        not_found_user: {
            title: 'Пользователь не найден',
            cause: 'Возможные причины:',
            invalid_input: {
                title: 'Неверно введен',
                mail: 'Email',
                tel: 'номер телефона',
            },
            not_registered: 'Пользователь не зарегистрирован в программе Status.',
        },
        no_place_in_family: 'В семье нет свободных мест.',
        myself: 'Вы попытались найти самого себя',
        found_not_king: '\u00A0не является главой семьи. Вы можете отправить запрос только главе счета.',
        found_without_family: '\u00A0свободен для участия в Status-Семья. Создать семью? Вы будете главой счета.',
        found_with_family: '\u00A0уже участник программы Status-Семья. Вы не можете его пригласить.',
        found_family_full: 'Но в семье нет свободных мест.',
        must_have_one_flight_to_create_family:
            'Для создания семьи Status Вам необходимо иметь хотя бы один перелет. Если вы уже летали с Utair, восстановите свои полеты',
        must_have_one_flight_to_join_family:
            'Для вступления в семью Вам необходимо иметь хотя бы один перелет. Если вы уже летали с Utair, восстановите свои полеты',
        impossible_invite_user_to_family: 'Невозможно пригласить участника в семью',
        impossible_create_family: 'Невозможно создать семью',
        impossible_join_family: 'Невозможно вступить в семью',
        restore_flight: 'Восстановить полёт',
        can_not_invite_start_level: 'Участников с уровнем Start нельзя пригласить в семью',
    },
    view: {
        extend: 'Управление семьей',
        compact: 'Компактный вид',
    },
    questions: {
        found_create: 'Создать семью?',
        found_join: 'Отправить запрос?',
        found_invite: 'Пригласить в семью?',
    },
    incoming_modal: {
        title: 'Принять в семью',
        subtitle: 'хочет участвовать с\u00A0вами',
        subtitle2: 'в\u00A0программе Status-Семья. Принимаем его?',
        accept: 'Принять',
        decline: 'Отклонить',
    },
    delete_member_modal: {
        title: 'Исключить из семьи',
        subtitle: 'Вы действительно хотите исключить пользователя',
        subtitle2: 'из семьи?',
        button: 'Исключить',
        success: 'Успешно',
    },
    change_head_modal: {
        title: 'Сменить главу семьи',
        subtitle: 'Хотите сделать главой счета пользователя',
        button: 'Сделать главой',
    },
    join_family_modal: {
        no_place: 'В семье нет свободных мест',
        button_create: 'Создать семью',
        button_send: 'Отправить',
    },
    search_modal: {
        input_card: 'Введите номер карты Status для поиска.',
        input_email: 'Введите адрес электронной почты для поиска.',
        input_tel: 'Введите номер телефона для поиска.',
        card: 'Карта Status',
        email: 'Email',
        tel: 'Номер телефона',
        tel_placeholder: '+7 (999) 999-99-99',
        button: 'Найти',
    },
    choose_method_modal: {
        title: 'Для участия в программе Status-Семья вам необходимо пригласить участника программы Status.',
        title2: 'Для вступления вам необходимо отправить заявку главе семьи. Выберите способ поиска главы семьи.',
        subtitle: 'Выберите способ поиска пользователя:',
        label_card: 'По номеру карты Status',
        label_email: 'По Email',
        label_tel: 'По номеру телефона',
    },
    none: {
        title: 'Семья',
        label: 'Объединяйтесь с другими участниками программы Status, копите и тратьте мили вместе!',
    },
    miles_for_shop: {
        title: 'Мили за покупки в магазинах',
        label: 'Делайте покупки в своих любимых магазинах и копите мили в программе Utair Status',
        button: 'Получить мили за покупки',
        policy: 'Переходя на сайт партнеров вы соглашаетесь на передачу и обработку персональных данных',
    },
    expanded: {
        request: {
            caption: 'Запрос от:',
            button_accept: 'Принять в семью',
            button_decline: 'Отклонить',
        },
        invite: {
            button: 'Пригласить в семью',
        },
        balance: {
            family_miles: 'семейных миль',
            personal_miles: 'Личные \nмили',
        },
        member_redeem: {
            button_tooltip: 'Тратить мили могут только\nпользователи старше 14 лет.',
            button_tooltip2: 'Только глава счета\nможет изменять привилегии.',
            error: {
                can_not: 'Не может тратить семейные мили',
            },
            miles: 'семейные мили',
            allow: 'Позволить тратить',
            can_not: 'Не может тратить',
            can: 'Может тратить',
        },
        delete_button: {
            tooltip: 'Только глава счета может\nисключать других членов семьи.',
            tooltip2: 'Нельзя исключить из семьи пользователя\nприсоединившегося менее полугода назад.',
        },
        change_head: {
            tooltip1: 'Только глава счета\nможет сменить главу.',
            tooltip2: 'Нельзя сделать главой счета\nпользователя младше 18 лет.',
        },
    },
    compact: {
        invite: 'Пригласить в\u00A0семью',
        new_request: 'Новый запрос в\u00A0семью',
    },
};
